import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import translations from '../translations';

const svcLinks = ['/anti-ddos', '/isp', '/cybersecurity-timeline', '/#contact'];
const coLinks = ['/about-us', '/#partners', '/#vendors', '/#contact'];
const legLinks = ['/privacy-policy'];

const Footer = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const isRTL = lang === 'ar';

  const renderLinks = (items, urls) =>
    items.map((s, i) => (
      <li key={s} className='py-2 text-sm hover:text-[#97d700] transition-colors duration-200'>
        <Link to={urls[i]}>{s}</Link>
      </li>
    ));

  return (
    <footer className="bg-[#0d1319]" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className={`max-w-6xl mx-auto py-16 px-6 grid lg:grid-cols-3 gap-8 text-gray-300 ${isRTL ? 'font-arabic' : ''}`}>
        <div>
          <h2 className='w-full text-3xl font-bold text-[#97d700] font-magistral'>{t.footer_brand}</h2>
          <p className='py-4 text-gray-400 leading-[1.9]'>{t.footer_desc}</p>
        </div>
        <div className='lg:col-span-2 flex justify-between mt-6'>
          <div>
            <h6 className='font-medium text-gray-400 mb-2'>{t.footer_services}</h6>
            <ul>{renderLinks(t.footer_svc, svcLinks)}</ul>
          </div>
          <div>
            <h6 className='font-medium text-gray-400 mb-2'>{t.footer_company}</h6>
            <ul>{renderLinks(t.footer_co, coLinks)}</ul>
          </div>
          <div>
            <h6 className='font-medium text-gray-400 mb-2'>{t.footer_legal}</h6>
            <ul>{renderLinks(t.footer_leg, legLinks)}</ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-6xl mx-auto px-6 py-6 text-center text-gray-500 text-sm">
          © {new Date().getFullYear()} شركة تكنولوجيا الموارد — Technology Resources. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
